import React from 'react';

import {
    STilesContainer
} from './styles';

import { H2 } from '../../atoms/Typography';
import Section from '../../layout/Section';
import SquareGenerator from '../../molecules/SquareGenerator';
import TileItem from './TileItem';

const SectionBigTiles = ({
    config,
    titleUnderline = false,
    background = '',
}) => {
    const {
        title,
        id,
        tileList,
        squares,
        forwardedRef,
    } = config;

    return (
        <Section
            background={ background }
            forwardedRef={ forwardedRef }
            id={ id }
        >
            <H2 titleUnderline={ titleUnderline }>
                { title }
            </H2>
            <STilesContainer>
                {
                    tileList.map( tile => (
                        <TileItem
                            key={ tile.id }
                            tileData={ tile }
                        />
                    ))
                }
            </STilesContainer>
            {
                !!squares && <SquareGenerator squares={ squares }/>
            }
        </Section>
    );
};

export default SectionBigTiles;
